import classNames from 'classnames';
import styles from './imageItem.module.scss';

type TImageItemProps = {
  image: IUploadImage;
  setFile: React.Dispatch<React.SetStateAction<IUploadImage[]>>;
  setOldImages?: React.Dispatch<React.SetStateAction<IOldImage[]>>;
};
const ImageItem = ({image, setFile, setOldImages}: TImageItemProps) => {
  const removeImage = () => {
    setFile(prev => prev.filter(x => x.file !== image.file));
  };

  const selectItem = () => {
    setFile(prev =>
      prev.map(x => {
        if (x.file === image.file) return {...x, isSelected: true};
        return {...x, isSelected: false};
      }),
    );

    if (setOldImages) {
      setOldImages(prev =>
        prev.map(x => ({
          ...x,
          isSelected: false,
        })),
      );
    }
  };
  return (
    <div className={styles['image-item']}>
      <div className="flex">
        <img src={URL.createObjectURL(image?.file)} alt={image?.file?.name} />
        <div className="pe-2">
          <div className="text-truncate w-100">
            <small className="text-gray-6">
              {image?.file?.name.substring(0, 20)}
            </small>
          </div>
          <div>
            <small className="text-gray-6 ">
              {(image?.file?.size / 1024).toFixed(0)}
            </small>
            <small className="text-gray-6 text-left ps-1">k</small>
          </div>
        </div>
      </div>
      <div className={classNames('flex', styles['image-item__operation'])}>
        <button className="ms-2" type="button" onClick={selectItem}>
          {image.isSelected ? (
            <i className="icon-flag-select text-primary"></i>
          ) : (
            <i className="icon-flag-deselect text-gray-6"></i>
          )}
        </button>
        <button
          className=" bg-error text-white mr-3"
          type="button"
          onClick={removeImage}
        >
          <i className="icon-trash fs-6"></i>
        </button>
      </div>
    </div>
  );
};

export default ImageItem;
